import { showConfirmDialog } from "vant";
import i18n from "@/locales";
import { useGlobalUser } from "@/stores/globalUser";

export const HOME_ROUTER = { name: "discover" };

export const routerHome = async () => {
  await window.$router.push(HOME_ROUTER);
};
export const routerBack = async ({
  backDoubleCheck = false,
  backDoubleCheckMessage = "",
} = {}) => {
  if (backDoubleCheck) {
    try {
      await showConfirmDialog({
        title: i18n.global.t("ConfirmModal.exitTitle"),
        message: backDoubleCheckMessage,
        confirmButtonText: i18n.global.t("Buttons.confirm"),
        cancelButtonText: i18n.global.t("Buttons.cancel"),
        showCancelButton: true,
      });
    } catch {
      // skip
      return;
    }
  }
  return !history.state.back || history.state.back.match("/login")
    ? routerHome()
    : window.$router.back();
};

export const discordUrl = "https://discord.gg/qGq9W2tUjR";
export const twitterUrl = "https://twitter.com/Anymate433638";
export const youtubeUrl = "https://www.youtube.com/@Anymate-jo4qn";
export const tiktokUrl = "https://www.tiktok.com/@anymate__";
export const goDiscordLink = () => {
  window.open(discordUrl, "_blank");
};
export const goTwitterLink = () => {
  window.open(twitterUrl, "_blank");
};
export const goYoutubeLink = () => {
  window.open(youtubeUrl, "_blank");
};

export const goTiktokLink = () => {
  window.open(tiktokUrl, "_blank");
};

export const goLoginIfNot = async () => {
  const globalUser = useGlobalUser();
  if (!globalUser.isLogin) {
    globalUser.loginModal.show = true;
  }
  return globalUser.isLogin;
};

export const goMateProfile = async (uuid: string) => {
  await window.$router.push({
    name: "mateHome",
    params: { uuid },
  });
};
